import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import SERVICES from '@/constants/services';
import moment from 'moment';
export default Vue.extend({
    name: 'createSecretConfirmSMS',
    props: {
        slotData: {
            required: true
        }
    },
    data() {
        return {
            form: {
                valid: false,
                loading: false,
                fields: {
                    code: {
                        value: '',
                        codeSendError: false,
                        codeIsSent: false,
                        codeSentBefore: false,
                        loading: false,
                        retryTimeout: 60,
                        retries: 3,
                        letRetry: false,
                        rules: [
                            (v) => Boolean(v.length) || this.$t('whitelistsPage.errors.fieldIsRequired')
                        ]
                    }
                }
            }
        };
    },
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    watch: {
        'form.fields.code.retryTimeout'(v) {
            const vm = this;
            if (v > 0) {
                setTimeout(() => {
                    vm.form.fields.code.retryTimeout = v - 1;
                }, 1000);
            }
            else
                vm.form.fields.code.letRetry = true;
        }
    },
    methods: {
        sendSMS() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.code.loading = true;
                vm.form.fields.code.codeSentBefore = false;
                const response = yield vm.services.mainService.sendSMS(null, SERVICES.SMS_OPERATIONS.whitelists.confirmCreateSecret);
                vm.form.fields.code.loading = false;
                if (response.success) {
                    vm.form.fields.code.codeIsSent = true;
                    vm.form.fields.code.letRetry = false;
                    vm.form.fields.code.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                    vm.form.fields.code.retries -= 1;
                    setTimeout(() => {
                        vm.form.fields.code.retryTimeout -= 1;
                    }, 1000);
                }
                else {
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.repeatAfter) {
                        vm.form.fields.code.codeSentBefore = true;
                        vm.form.fields.code.codeIsSent = true;
                        vm.form.fields.code.letRetry = false;
                        vm.form.fields.code.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                        vm.form.fields.code.retries -= 1;
                        setTimeout(() => {
                            vm.form.fields.code.retryTimeout -= 1;
                        }, 1000);
                    }
                    else {
                        vm.form.fields.code.codeSendError = true;
                        vm.form.fields.code.letRetry = true;
                    }
                }
            });
        },
        handleClickRestartProcess() {
            window.location.reload();
        }
    }
});
